import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const reasonOptions = [
    'Vehicle unavailable',
    'Date unavailable',
    'Pricing issue',
    'Operational issue',
    'Other',
];

const CancelBookingModal = ({ show, onClose, onSubmit, loading }) => {
    const [reason, setReason] = useState('');
    const [note, setNote] = useState('');

    useEffect(() => {
        if (show) {
            setReason('');
            setNote('');
        }
    }, [show]);

    const handleSubmit = () => {
        onSubmit({
            reason,
            note: note.trim(),
        });
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Decline this booking?</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p className="text-danger">
                    This will not change the booking status. A supplier note will be saved
                    in the booking history.
                </p>

                <Form.Group className="mb-3">
                    <Form.Label>Reason</Form.Label>
                    <Form.Select
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                    >
                        <option value="">Select a reason</option>
                        {reasonOptions.map((item) => (
                            <option key={item} value={item}>
                                {item}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <Form.Group>
                    <Form.Label>
                        {reason === 'Other' ? 'Details' : 'Additional note'}
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        placeholder="Add a note for the booking history"
                    />
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={loading}>
                    Close
                </Button>
                <Button
                    variant="danger"
                    onClick={handleSubmit}
                    disabled={!reason || (reason === 'Other' && !note.trim()) || loading}
                >
                    Save Note
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CancelBookingModal;